import * as React from 'react';
import { SVGProps } from 'react';

const IconProcessingSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g fillRule="evenodd" clipRule="evenodd">
      <path d="M6.75 1h-1.5l-.443 1.18a3.996 3.996 0 0 0-1.517.878L2.045 2.85l-.75 1.3.801.974a4.014 4.014 0 0 0 0 1.752l-.801.974.75 1.3 1.245-.208c.43.396.946.699 1.517.877L5.25 11h1.5l.443-1.18a3.995 3.995 0 0 0 1.517-.878l1.245.208.75-1.3-.801-.974a4.014 4.014 0 0 0 0-1.752l.801-.974-.75-1.3-1.245.208a3.996 3.996 0 0 0-1.517-.877L6.75 1zM8 6a2 2 0 1 1-4 0 2 2 0 0 1 4 0z" />
      <path d="M11.5 8h1l.377 1.13c.441.135.84.369 1.17.676l1.167-.239.5.866-.79.891a3.008 3.008 0 0 1 0 1.351l.79.892-.5.866-1.168-.239c-.33.307-.728.541-1.17.676L12.5 16h-1l-.377-1.13a2.997 2.997 0 0 1-1.17-.676l-1.167.239-.5-.866.79-.891a3.01 3.01 0 0 1 0-1.352l-.79-.891.5-.866 1.168.239c.33-.307.728-.541 1.17-.676L11.5 8zm1.5 4a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" />
    </g>
  </svg>
);
export default IconProcessingSizeS;
